import React, { Component } from 'react'
import About from '../img/About.png'
import Favorite from '../img/Favorite.png'
import Restaurant from '../img/Store.jpg'
import Eggrolls from '../img/Eggrolls.jpg'
import SpringRolls from '../img/SpringRolls.jpeg'
import FavoriteFoodScreen from '../components/favFoodScreen'
import './styles/textImg.css';
import './styles/parallax.css';
import './styles/description.css';
import Parallax from '../components/parallax';
import VietnamCuisineDescription from '../textFile/vietnamCuisineDescription';
import EggrollDescription from '../textFile/eggrollsDescription';
import SpringRollsDescription from '../textFile/springrollsDescription'
import { ToastContainer, Bounce, toast } from 'react-toastify'
import './styles/homepage.css'

/**
 * Converts a JSX-formatted string into real React elements safely.
 * Handles <b>, </b>, and <br /> variations without injecting raw HTML.
 */
const convertStringToJsx = (inputString) => {
  if (!inputString) return '';

  const trimmedInput = inputString.trim();
  const tagRegex = /(<\/?[a-zA-Z0-9]+\s*\/?>)/g;
  const tokens = trimmedInput.split(tagRegex);

  let isBold = false;
  const jsxResult = [];

  tokens.forEach((token, index) => {
    if (token === '') return;

    if (token === '<b>') {
      isBold = true;
      return;
    }
    if (token === '</b>') {
      isBold = false;
      return;
    }
    if (token === '<br />' || token === '<br/>' || token === '<br>') {
      jsxResult.push(<br key={`br-${index}`} />);
      return;
    }

    if (isBold) {
      jsxResult.push(<b key={`b-${index}`}>{token}</b>);
    } else {
      jsxResult.push(token);
    }
  });

  return jsxResult;
};

export default class Homepage extends Component {
  constructor(props){
    super(props);
    this.state = {};      
    const message = process.env.REACT_APP_NOTIFICATION_MESSAGE
    const isNotificationOn = process.env.REACT_APP_NOTIFICATION_ON

    if(isNotificationOn === 'true'){
      console.log(1)
      // Parse the .env text configuration into a valid JSX array reference
      const parsedMessage = convertStringToJsx(message);
      
      // Toast the processed JSX content wrapped in a container element
      toast(<span>{parsedMessage}</span>);
    }
  }
  render() {
    return (
      <div className='content_holder'>
        <ToastContainer
          position="top-center"
          autoClose={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          theme="light"
          transition={Bounce}
          className={"notification_box"}
        />
        <FavoriteFoodScreen></FavoriteFoodScreen>
        <div className='text_img placeholderTitle'>
          <img src={About} alt='text'></img>
        </div>
        <Parallax background={Restaurant} primary='Established in 2000' textID='Restaurant_text' parallaxID='Restaurant_parallax' fontSize={window.innerWidth * 0.030}></Parallax>
        <div className='description_section'>
          <h3 className='description_title'>Vietnamese Cuisine</h3>
          <p className='description_para'>
            {VietnamCuisineDescription}
          </p>
        </div>
        <div className='text_img placeholderTitle'>
          <img src={Favorite} alt='text' style={{width: '40%'}}></img>
        </div>
        <Parallax background={Eggrolls} primary='Crispy and full of texture' textID='Eggrolls_text' parallaxID='Eggrolls_parallax' fontSize={window.innerWidth * 0.030}></Parallax>
        <div className='description_section'>
          <h3 className='description_title'>EggRolls</h3>
          <p className='description_para'>
           {EggrollDescription}
          </p>
        </div>
        <Parallax background={SpringRolls} primary='Fresh and delicacy' textID='Springrolls_text' parallaxID='Springrolls_parallax' fontSize={window.innerWidth * 0.030}></Parallax>
        <div className='description_section'>
          <h3 className='description_title'>SpringRolls</h3>
          <p className='description_para'>
            {SpringRollsDescription}
          </p>
        </div>      
      </div>
    )
  }
}
